export const getDirValue = (isRTL: boolean): string => {
  return isRTL ? 'rtl' : 'ltr';
};
